module.exports = __webpack_public_path__ + "ch.svg?987cb82c1cadb50c89fe1e58dec40c31";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ch.svg
// module id = 1295
// module chunks = 0